import { render, staticRenderFns } from "./jt808-set-parameterdata-modal.vue?vue&type=template&id=4fe129b9&scoped=true"
import script from "./jt808-set-parameterdata-modal.vue?vue&type=script&lang=js"
export * from "./jt808-set-parameterdata-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe129b9",
  null
  
)

export default component.exports